import React from 'react'
import SearchSvg from '../../../../assets/images/search-icon.svg'
import './SearchText.scss'

const SearchText = ({ value, onChange }) => {

  return (
    <div className='search-text-container'>
      <img src={SearchSvg} alt='Searchsvg'/>
      <input value={value} onChange={e => onChange(e.target.value)} placeholder='Buscar' spellCheck="false" />
    </div>
  )

}

export default SearchText
